module.exports = __webpack_public_path__ + "img/34.54edc713.jpg";